<div class="list-documents" *ngIf="documents && documents.length > 0">
    <div class="document" *ngFor="let document of documents">
        <div class="doc-line" (click)="openDocument(document)">
            <div class="doc-icon">
                <img [src]="getFileExt(document)" width="20" height="20">
            </div>
            <div class="doc-type" *ngIf="showType">{{ document.entityType | translate }}</div>
            <div class="doc-name" *ngIf="!showDescription || (!document.description && document.fileName)">{{ document.fileName }}</div>
            <div class="doc-description" *ngIf="showDescription && document.description">
                {{ document.description }}
                <span class="author" *ngIf="document.author"> ( <fa-icon [icon]="['fas', 'user']"></fa-icon> {{ document.author }} )</span>
                <span class="date" *ngIf="document.createdAt"> <fa-icon [icon]="['fas', 'calendar']"></fa-icon> {{ document.createdAt | date: 'shortDate':undefined:locale  }} </span>
            </div>
            <div class="doc-delete" *ngIf="showDelete">
                <fa-icon [icon]="['fas', 'times-circle']" class="text-danger" (click)="deleteDocument($event,document) "></fa-icon>
            </div>
        </div>
    </div>
</div>
<div class="no-documents" *ngIf="!documents || documents.length === 0">
    <fa-icon [icon]="['fas', 'triangle-exclamation']" class="text-danger"></fa-icon>&nbsp;
    Aucun document trouvé
</div>